export default {
  sm: '40em',
  md: '52em',
  lg: '64em',
  xl: '80em',
}
